import { Routes } from '@angular/router';
import { ShopListComponent } from './shop-list.component';

export const SHOPLIST_ROUTES: Routes = [
  {
    path: '',
    component: ShopListComponent,
    data: { landingPage: true }
  },
  {
    path: 'map',
    loadComponent: () =>
      import('../../../pages/map-modal/map-modal.component').then(m => m.MapModalComponent),
    outlet: 'modal',
    pathMatch: 'full',
    data: { skipRouteLocalization: true }
  },
  {
    path: 'map/:shopId',
    loadComponent: () =>
      import('../../../pages/map-modal/map-modal.component').then(m => m.MapModalComponent),
    outlet: 'modal',
    pathMatch: 'full',
    data: { skipRouteLocalization: true }
  }
];
